export enum Lifetime {
  THREE_MONTHS = 90,
  SIX_MONTHS = 180,
  YEAR = 365,
  YEAR_AND_A_HALF = 545,
  TWO_YEARS = 730,
  THREE_YEARS = 1095,
}
